import React from 'react';
import { useTranslation } from 'react-i18next';
import { commonStyles } from '../../../styles/commonStyles';
import { InfoTooltip, InfoTooltipItem } from '../../../components/InfoTooltip';

// A coverage label with a trailing (i) tooltip explaining the coverage
// (screens.rechtsbijstand.coverageInfo.*, from the official verzekeringskaart/voorwaarden).
// The last few characters of the label are glued to the icon in a nowrap span so the icon
// never drops onto a line of its own; interaction/a11y live in the shared InfoTooltip.
const TAIL = 4;

interface CoverageInfoLabelProps {
  label: string;
  infoKey: string;
}

export const CoverageInfoLabel: React.FC<CoverageInfoLabelProps> = ({ label, infoKey }) => {
  const { t, i18n } = useTranslation();

  const head = label.length > TAIL ? label.slice(0, -TAIL) : '';
  const tail = label.length > TAIL ? label.slice(-TAIL) : label;

  const base = `screens.rechtsbijstand.coverageInfo.${infoKey}`;
  const items: InfoTooltipItem[] = [];
  for (let i = 1; i18n.exists(`${base}.item${i}`); i++) items.push({ text: t(`${base}.item${i}`) });

  return (
    <span style={commonStyles.coverageLabelInline}>
      {head}
      <span style={commonStyles.labelTailNoWrap}>
        {tail}
        <InfoTooltip title={t(`${base}.title`)} items={items} />
      </span>
    </span>
  );
};

export default CoverageInfoLabel;
